import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Actions, ofActionDispatched, Store } from '@ngxs/store';
import { UiStoreHelperService } from '@radioking/shared/common-services';
import amplitude from 'amplitude-js';
import { Observable, Subscription } from 'rxjs';
import { mapTo, startWith, take } from 'rxjs/operators';

import { SchedulerTrack } from '../../../../../../scheduler-core/src/lib/models/scheduler-core.model';
import { SchedulerCoreState } from '../../../../../../scheduler-core/src/lib/states/scheduler-core.state';
import { Program, ProgramPreview } from '../../../models/programs.model';
import {
  PreviewProgramFailure,
  PreviewProgramRequest,
  PreviewProgramSuccess,
} from '../../../states/programs.actions';

@Component({
  selector: 'rk-preview-program-modal',
  templateUrl: './preview-program-modal.component.html',
  styleUrls: ['./preview-program-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewProgramModalComponent implements OnInit, OnDestroy {
  currentCycle = 1;
  isLoading$: Observable<boolean>;
  isLoadingCycle$: Observable<boolean>;
  programPreview: ProgramPreview[] = [];
  trackIntro: SchedulerTrack | null;
  trackExtro: SchedulerTrack | null;
  subscription = new Subscription();

  constructor(
    private readonly store: Store,
    private readonly actions$: Actions,
    private readonly cdr: ChangeDetectorRef,
    private readonly uiHelper: UiStoreHelperService,
    public readonly dialogRef: MatDialogRef<PreviewProgramModalComponent>,
    @Inject(MAT_DIALOG_DATA) public program: Program,
  ) {}

  ngOnInit(): void {
    amplitude.getInstance().logEvent('preview_button');
    const trackWithId = this.store.selectSnapshot(SchedulerCoreState.trackWithId);
    const { idTrackIntro, idTrackExtro } = this.program;
    this.trackIntro = idTrackIntro ? trackWithId(idTrackIntro) : null;
    this.trackExtro = idTrackExtro ? trackWithId(idTrackExtro) : null;
    this.previewCycle(this.currentCycle);
    this.subscription.add(
      this.actions$
        .pipe(ofActionDispatched(PreviewProgramSuccess))
        .subscribe(({ programPreview }: PreviewProgramSuccess) => {
          this.programPreview.push(...programPreview);
          this.cdr.detectChanges();
        }),
    );
    this.isLoading$ = this.actions$.pipe(
      ofActionDispatched(PreviewProgramSuccess, PreviewProgramFailure),
      mapTo(false),
      startWith(true),
      take(2),
    );
    this.isLoadingCycle$ = this.uiHelper.getLoadingState(PreviewProgramRequest, [
      PreviewProgramSuccess,
      PreviewProgramFailure,
    ]);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  @Dispatch()
  previewCycle(cycleIdx: number) {
    return new PreviewProgramRequest(this.program.id, cycleIdx);
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  newCycle() {
    this.previewCycle(++this.currentCycle);
  }

  modalStyle() {
    return {
      width: '800px',
      'max-width': '80vw',
    };
  }
}
